function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M35.4666 21.8571H2.53326V2.57141H35.4666V21.8571ZM3.79993 20.5714H34.1999V3.85713H3.79993V20.5714Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.5 23.7858H34.2V25.0715H9.5V23.7858Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.60004 23.1429H8.8667V25.7144H7.60004V23.1429Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M3.79993 23.7858H6.96659V25.0715H3.79993V23.7858Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5667 18.3973V6.03113L26.7493 12.2142L14.5667 18.3973ZM15.8333 8.11162V16.3168L23.9173 12.2142L15.8333 8.11162Z",
  fill: "white"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M36.1 0H1.9C0.850732 0 0 0.863525 0 1.92857V26.3571C0 27.4222 0.850732 28.2857 1.9 28.2857H13.3V32.1429H6.96667V36H31.0333V32.1429H24.7V28.2857H36.1C37.1493 28.2857 38 27.4222 38 26.3571V1.92857C38 0.863525 37.1493 0 36.1 0ZM29.7667 33.4286V34.7143H8.23333V33.4286H29.7667ZM23.4333 32.1429H14.5667V28.2857H23.4333V32.1429ZM36.7333 26.3571C36.7333 26.7122 36.4498 27 36.1 27H1.9C1.55024 27 1.26667 26.7122 1.26667 26.3571V1.92857C1.26667 1.57356 1.55024 1.28571 1.9 1.28571H36.1C36.4498 1.28571 36.7333 1.57356 36.7333 1.92857V26.3571Z",
  fill: "white"
});

var SvgVideo = function SvgVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/video.12e4085f.svg";
export { ForwardRef as ReactComponent };